/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

/**
 * Checks whether a value is a non-empty object or array.
 *
 * Intended for values produced by `JSON.parse`. Uses own enumerable keys, so
 * built-in objects such as `Map`, `Set`, and `Date` are treated as empty.
 *
 * The type predicate only guarantees `object` when it returns `true`; `false`
 * also includes empty objects and arrays.
 *
 * @param value - Value to check.
 * @returns `true` when the value is a non-null object or array with entries.
 *
 * @example
 * isNonEmptyObject({ rootHints: ["MAGISK"] }) // true
 * isNonEmptyObject([]) // false
 * isNonEmptyObject(null) // false
 */
export function isNonEmptyObject(value: unknown): value is object {
    return typeof value === "object" && value !== null && Object.keys(value).length > 0
}
